import Api from 'api';
import './_styles.scss';
import React from "react";
import MainBody from './Body';
import Filters from './Filters';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { Items, Navigation, Footer, Categories } from "components";

class Products extends React.Component {

  constructor(props) {

    super(props);

    this.api = new Api();

    this.state = {

      products: [],
      products_filter: [],
      active_category: null,

      filters: {
        brands: [],
        min_rating: 0,
        min_price: 0,
        max_price: 0,
        pricing: {
          min: 0,
          max: 0
        },
        out_of_stock: true
      },

      sort_by: null

    }

  }

  componentDidMount = () => {

    const { category } = this.props.match.params;

    return this.update_props(category, false);

  }

  static getDerivedStateFromProps(props, state) {

    const { active_category } = state;

    const { category } = props.match.params;

    if (category === active_category) return null;

    if (!!active_category) window.location.reload();

    return null;

  }

  update_props = (category, reload=true) => {

    const { active_category } = this.state;

    if (active_category === category) return null;

    return this.updated_category(category, reload);

  }

  updated_category = (Category, Reload) => {

    const { active_category } = this.state;

    if (active_category === Category) return null;

    if (!!Reload) return window.location.reload();

    return this.fetch_api_products(Category);

  }

  fetch_api_products = async (active_category='') => {

    const { docs = [] } = await this.api.fetch('products', 'category', active_category);

    const products = docs.map(query_snapshot => query_snapshot.data());

    this.setState({ active_category, products: products, products_filter: products });

  }

  apply_filter = (filter_name = '', filter_value) => {

    const { filters } = this.state;

    let products_filter = [...this.state.products];

    const updated_filters = { ...filters, [filter_name]: filter_value };

    Object.keys(updated_filters).map(a => {

      const value = updated_filters[a];

      //Filter Based On Price: Min-Max
      if (a === 'pricing' && (value.min > 0 || value.max > 0)) products_filter = products_filter.filter(a => {
        const price = parseInt(a.pricing.price || 0);
        return ((price >= value.min) && (price <= value.max));
      });

      //Filter Based On Rating: Min
      if (a === 'min_rating' && value !== 0) products_filter = products_filter.filter(a => {
        const price = parseInt(a.pricing.price || 0);
        return (price > value);
      });

      //Filter Based On Stock Quantity
      if (a === 'out_of_stock' && !value) products_filter = products_filter.filter(a => (parseInt(a.stock) > 0));

      //Filter Based On Brands.
      if (a === 'brands' && value.length !== 0) products_filter = products_filter.filter(a => value.includes(a.vendor));

      return null;

    });

    return this.setState({ filters: updated_filters, products_filter });

  }

  apply_sorting = (products = []) => {

    const { sort_by } = this.state;

    if (!sort_by || sort_by === 'Alphabetically, A-Z') return products.sort((a, b) => a.title.localeCompare(b.title));

    if (sort_by === 'Alphabetically, Z-A') return products.sort((a, b) => a.title.localeCompare(b.title)).reverse();

    if (sort_by === 'Price, low to high') return products.sort((a, b) => a.pricing.price-b.pricing.price);

    if (sort_by === 'Price, high to low') return products.sort((a, b) => b.pricing.price-a.pricing.price);

  }

  render() {

    const { products, products_filter, filters, active_category } = this.state;

    const category = this.props.categories.filter(a => a.title === active_category)[0] || {};

    return (
      <section className='Section-Catalog'>

        <Helmet>
          <title>{`${active_category || 'Categories'} | Adenzo Comfies`}</title>
        </Helmet>

        <Navigation />

        <div className="Catalog-Section-Wrapper">

          <Filters
            products={products}
            current_filters={filters}
            onFilter={this.apply_filter}
          />

          <MainBody
            active_category={category}
            data={this.apply_sorting(products_filter)}
            change_sorting={(a = '') => this.setState({ sort_by: a })}
          />

        </div>

        <Categories
          data={this.props.categories}
          start={0}
          end={4}
          minimal
        />

        <Items
          data={products.slice(0, 9)}
          caption='Featured Recommendations'
        />

        <Footer />

      </section>
    );
  }
}

const mapStateToProps = ({ cache }) => ({
  categories: cache.categories,
});

export default connect(mapStateToProps, {})(Products);
